import { render, staticRenderFns } from "./Insight_Play.vue?vue&type=template&id=cedc1f4c&scoped=true"
import script from "./Insight_Play.vue?vue&type=script&lang=js"
export * from "./Insight_Play.vue?vue&type=script&lang=js"
import style0 from "./Insight_Play.vue?vue&type=style&index=0&id=cedc1f4c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cedc1f4c",
  null
  
)

export default component.exports